import { OEM_CONSTANTS } from "../constants/oemConstants";

const initialState = {
  partners: [],
  scanTypes: [],
  oemNames: [],
  licenses: [],
  licensesList: [],
  oemPartnerUsers: [],
  loading: false,
  formLoading: false,
  scanTypesLoading: false,
  oemNamesLoading: false,
  licensesLoading: false,
  licensesListLoading: false,
  oemPartnerUsersLoading: false,
  error: null,
  success: false,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
};

const oemReducer = (state = initialState, action) => {
  switch (action.type) {
    case OEM_CONSTANTS.ADD_OEM_REQUEST:
    case "EDIT_OEM_REQUEST":
    case "DELETE_OEM_REQUEST":
      return {
        ...state,
        formLoading: true,
        error: null,
      };

    case OEM_CONSTANTS.GET_OEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case OEM_CONSTANTS.ADD_OEM_SUCCESS:
      return {
        ...state,
        formLoading: false,
        success: true,
        error: null,
      };

    case "EDIT_OEM_SUCCESS":
    case "DELETE_OEM_SUCCESS":
      return {
        ...state,
        formLoading: false,
        success: true,
        error: null,
      };

    case OEM_CONSTANTS.GET_OEM_SUCCESS:
      return {
        ...state,
        loading: false,
        partners: action.payload.response || [],
        pagination: action.payload.pagination || state.pagination,
        success: false,
        error: null,
      };

    case OEM_CONSTANTS.ADD_OEM_FAILURE:
    case "EDIT_OEM_FAILURE":
    case "DELETE_OEM_FAILURE":
      return {
        ...state,
        formLoading: false,
        error: action.payload,
      };

    case OEM_CONSTANTS.GET_OEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case OEM_CONSTANTS.GET_SCAN_TYPES_REQUEST:
      return {
        ...state,
        scanTypesLoading: true,
        error: null,
      };

    case OEM_CONSTANTS.GET_SCAN_TYPES_SUCCESS:
      return {
        ...state,
        scanTypesLoading: false,
        scanTypes: action.payload.response || [],
        error: null,
      };

    case OEM_CONSTANTS.GET_SCAN_TYPES_FAILURE:
      return {
        ...state,
        scanTypesLoading: false,
        error: action.payload,
      };

    case OEM_CONSTANTS.GET_OEM_NAMES_REQUEST:
      return {
        ...state,
        oemNamesLoading: true,
        error: null,
      };

    case OEM_CONSTANTS.GET_OEM_NAMES_SUCCESS:
      return {
        ...state,
        oemNamesLoading: false,
        oemNames: action.payload.response || [],
        error: null,
      };

    case OEM_CONSTANTS.GET_OEM_NAMES_FAILURE:
      return {
        ...state,
        oemNamesLoading: false,
        error: action.payload,
      };

    case "RESET_OEM_PASSWORD_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "RESET_OEM_PASSWORD_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
      };

    case "RESET_OEM_PASSWORD_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case OEM_CONSTANTS.GET_LICENSES_REQUEST:
      return {
        ...state,
        licensesLoading: true,
        error: null,
      };

    case OEM_CONSTANTS.GET_LICENSES_SUCCESS:
      return {
        ...state,
        licensesLoading: false,
        licenses: action.payload.response || [],
        error: null,
      };

    case OEM_CONSTANTS.GET_LICENSES_FAILURE:
      return {
        ...state,
        licensesLoading: false,
        error: action.payload,
      };

    case OEM_CONSTANTS.GET_LICENSES_LIST_REQUEST:
      return {
        ...state,
        licensesListLoading: true,
        error: null,
      };

    case OEM_CONSTANTS.GET_LICENSES_LIST_SUCCESS:
      return {
        ...state,
        licensesListLoading: false,
        licensesList: action.payload.response || [],
        error: null,
      };

    case OEM_CONSTANTS.GET_LICENSES_LIST_FAILURE:
      return {
        ...state,
        licensesListLoading: false,
        error: action.payload,
      };

    case OEM_CONSTANTS.GET_OEM_PARTNER_USERS_REQUEST:
      return {
        ...state,
        oemPartnerUsersLoading: true,
        error: null,
      };

    case OEM_CONSTANTS.GET_OEM_PARTNER_USERS_SUCCESS:
      return {
        ...state,
        oemPartnerUsersLoading: false,
        oemPartnerUsers: action.payload.response || [],
        error: null,
      };

    case OEM_CONSTANTS.GET_OEM_PARTNER_USERS_FAILURE:
      return {
        ...state,
        oemPartnerUsersLoading: false,
        error: action.payload,
      };

    case OEM_CONSTANTS.CLEAR_OEM_SUCCESS:
      return {
        ...state,
        success: false,
        error: null,
      };
    case "RESET_OEM_STATE":
      return {
        ...state,
        success: false,
        error: null,
      };

    default:
      return state;
  }
};

export default oemReducer;
